module.exports = __webpack_public_path__ + "img/small_whale01.4d21ae37.jpg";